import type { StepConfigFor } from '../getStepConfig.types.ts';

export const UploadReferralLetterOfSupportStepConfig = {
  title: ({ isHealthcareProvider }) =>
    isHealthcareProvider ? "Patient's Referral Letter of Support" : 'Upload Your Referral Letter of Support',

  statuses: {
    NOT_STARTED: {
      label: 'Not Uploaded',
      cta: 'Upload Now',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with uploading their referral letter of support'
          : 'Please upload your referral letter of support from your GP or specialist',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'Patient needs to upload their referral letter of support'
          : 'Please upload your referral letter of support from your GP or specialist',
    },

    PENDING: {
      label: 'Under Review',
      cta: 'Resubmit',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their referral letter of support. Please review them and verify their details'
          : 'You have submitted your referral letter of support from your GP or specialist. We are reviewing them and will update you shortly',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their referral letter of support. We need to review it and update the status'
          : 'Your referral letter of support from your GP or specialist is being reviewed. We will update you shortly',
    },

    COMPLETED: {
      label: 'Approved',
      cta: 'View',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully uploaded their referral letter of support'
          : 'You have successfully uploaded your referral letter of support from your GP or specialist',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully uploaded their referral letter of support'
          : 'You have successfully uploaded your referral letter of support from your GP or specialist',
    },

    ERROR: {
      label: 'Needs Resubmission',
      cta: 'Resubmit Now',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The uploaded file is incorrect, missing or has missing required information. The patient will need to resubmit it'
          : 'There was an issue with your referral letter of support from your GP or specialist. Please resubmit it',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The uploaded file is incorrect, missing or has missing required information. The patient will need to resubmit it'
          : 'There was an issue with your referral letter of support from your GP or specialist. Please resubmit it',
    },
  },
} satisfies StepConfigFor<'UPLOAD_REFERRAL_LETTER_OF_SUPPORT'>;
